import React from 'react';
import AudioBookItem from '../../components/AudioBookItem/AudioBookItem';
import style from './VoicesSection.module.css';
import mediaItems from '../../jsons/voiceRecording.json'


const VoicesSection = () => {

  return (
    <div className={style.voicesSectionContainer}>
      {mediaItems.map((item, index) => (
        <AudioBookItem
          key={index}
          type={item.type}
          audioImg={item.image}
          audio={item.source}
        />
      ))}
    </div>
  );
};

export default VoicesSection;
